import Vue from "vue";
import { MglMap, MglMarker } from "../libs/bow-vue-mapbox/main";

Vue.component("MglMap", MglMap);
Vue.component("MglMarker", MglMarker);
